import ForumRounded from '@mui/icons-material/ForumRounded';
import DnsRounded from '@mui/icons-material/DnsRounded';
import HistoryRounded from '@mui/icons-material/HistoryRounded';
import KeyRounded from '@mui/icons-material/KeyRounded';
import LayersRounded from '@mui/icons-material/LayersRounded';
import ManageAccountsRounded from '@mui/icons-material/ManageAccountsRounded';
import MonitorHeartRounded from '@mui/icons-material/MonitorHeartRounded';
import SpaceDashboardRounded from '@mui/icons-material/SpaceDashboardRounded';
import SettingsRounded from '@mui/icons-material/SettingsRounded';
import SupportAgentRounded from '@mui/icons-material/SupportAgentRounded';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import DeliveryDiningRounded from '@mui/icons-material/DeliveryDiningRounded';
import EmailRounded from '@mui/icons-material/EmailRounded';
import type { SvgIconComponent } from '@mui/icons-material';
import type { Capability } from '../auth/capabilities';

export interface NavItem {
  label: string;
  path: string;
  icon: SvgIconComponent;
  /** Any one of these capabilities shows the item (the API enforces access). */
  anyOf: Capability[];
  keywords?: string;
}

export interface NavGroup {
  title: string;
  items: NavItem[];
}

export const NAV: NavGroup[] = [
  {
    title: 'Overview',
    items: [
      {
        label: 'Dashboard',
        path: '/',
        icon: SpaceDashboardRounded,
        anyOf: ['tenants.view'],
        keywords: 'home kpi signups',
      },
    ],
  },
  {
    title: 'Customers',
    items: [
      {
        label: 'Tenants',
        path: '/tenants',
        icon: DnsRounded,
        anyOf: ['tenants.view'],
        keywords: 'shops customers subscription suspend',
      },
      {
        label: 'Activation codes',
        path: '/activation-codes',
        icon: KeyRounded,
        anyOf: ['codes.manage'],
        keywords: 'license renew redeem',
      },
      {
        label: 'Plans',
        path: '/plans',
        icon: LayersRounded,
        anyOf: ['tenants.view'],
        keywords: 'pricing billing',
      },
      {
        label: 'WhatsApp revenue',
        path: '/whatsapp-revenue',
        icon: WhatsAppIcon,
        anyOf: ['subscriptions.manage'],
        keywords: 'whatsapp plugin addon revenue',
      },
      {
        label: 'Foodpanda revenue',
        path: '/foodpanda-revenue',
        icon: DeliveryDiningRounded,
        anyOf: ['subscriptions.manage'],
        keywords: 'foodpanda plugin addon revenue delivery',
      },
      {
        label: 'Email revenue',
        path: '/email-revenue',
        icon: EmailRounded,
        anyOf: ['subscriptions.manage'],
        keywords: 'email mail smtp plugin addon revenue',
      },
      {
        label: 'Support inbox',
        path: '/inbox',
        icon: ForumRounded,
        anyOf: ['support.chat'],
        keywords: 'chat messages help desk tickets replies',
      },
      {
        label: 'Support access',
        path: '/support',
        icon: SupportAgentRounded,
        anyOf: ['tenants.view'],
        keywords: 'grants help desk',
      },
    ],
  },
  {
    title: 'Platform',
    items: [
      {
        label: 'Audit log',
        path: '/audit',
        icon: HistoryRounded,
        anyOf: ['audit.view'],
        keywords: 'activity history events',
      },
      {
        label: 'System health',
        path: '/health',
        icon: MonitorHeartRounded,
        anyOf: ['tenants.view'],
        keywords: 'status database sync uptime',
      },
      {
        label: 'Admins',
        path: '/admins',
        icon: ManageAccountsRounded,
        anyOf: ['admins.manage'],
        keywords: 'accounts users team mfa',
      },
      {
        label: 'Settings',
        path: '/settings',
        icon: SettingsRounded,
        anyOf: ['tenants.view'],
        keywords: 'trial period grace days new shops',
      },
    ],
  },
];

export function visibleNav(can: (capability: Capability) => boolean): NavGroup[] {
  return NAV.map((g) => ({
    ...g,
    items: g.items.filter((i) => i.anyOf.some((k) => can(k))),
  })).filter((g) => g.items.length > 0);
}
